if (!customElements.get("toggle-cross-sell")) {
  customElements.define(
    "toggle-cross-sell",

    class ToggleCrossSell extends HTMLElement {
      constructor() {
        super();

        this.main_product_form =
          this.closest(".product").querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (this.main_product_form === null) return console.error("ToggleCrossSell: No product form found");

        // Cache pour stocker les prix
        this.priceButton = document.querySelector("#price-button");
        this.mainProductPrice = 0;
        this.variantChangeUnsubscriber = null;
        this.priceButtonObserver = null;
        this.isUpdatingPrice = false; // Flag pour éviter les boucles infinies

        // Éléments pour la navigation avec flèches
        this.productsContainer = this.querySelector(".toggle-cross-sell__products");
        this.arrowLeft = this.querySelector(".toggle-cross-sell__arrow--left");
        this.arrowRight = this.querySelector(".toggle-cross-sell__arrow--right");

        // Initialiser le prix du produit principal
        this.initMainProductPrice();
      }

      connectedCallback() {
        // Si on clique autour bouton ou de la checkbox, on veut quand même toggle le cross-sell
        this.addEventListener("click", this.onToggleProduct.bind(this));
        this.querySelectorAll(".toggle-cross-sell__product").forEach((product) => {
          // On écoute les changement de variante
          if (product.querySelector(".deployer-select") != null) {
            product.querySelector(".deployer-select").addEventListener("change", this.variantChanged.bind(this, product));
          }
          // On écoute les clics sur le bouton d'ajout
          if (product.querySelector(".deployer-button") != null) {
            product.querySelector(".deployer-button").addEventListener("click", this.toggleAddButton.bind(this, product.querySelector(".deployer-button")));
          }
        });

        // S'abonner aux changements de variante du produit principal
        if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onMainProductVariantChange.bind(this));
        }

        // Observer les changements du prix dans le bouton (pour gérer les mises à jour externes)
        this.setupPriceButtonObserver();

        // Initialiser la navigation par flèches
        this.initArrowNavigation();

        // Mise à jour initiale du prix
        this.updateTotalPrice();
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onToggleProduct.bind(this));
        this.querySelectorAll(".toggle-cross-sell__product").forEach((product) => {
          if (product.querySelector(".deployer-select") != null) {
            product.querySelector(".deployer-select").removeEventListener("change", this.variantChanged.bind(this, product));
          }
          if (product.querySelector(".deployer-button") != null) {
            product.querySelector(".deployer-button").removeEventListener("click", this.toggleAddButton.bind(this, product.querySelector(".deployer-button")));
          }
        });

        // Se désabonner des événements du produit principal
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        // Arrêter l'observation du bouton prix
        if (this.priceButtonObserver) {
          this.priceButtonObserver.disconnect();
        }

        // Nettoyer les event listeners des flèches
        this.cleanupArrowNavigation();
      }

      // Change l'état du bouton d'ajout
      toggleAddButton(button, active) {
        if (button.classList.contains("deployer-button--secondary") || active == true) {
          button.classList.add("deployer-button--active");
          button.classList.remove("deployer-button--secondary");
        } else {
          button.classList.remove("deployer-button--active");
          button.classList.add("deployer-button--secondary");
        }
      }

      onToggleProduct(event) {
        const checkbox = event.target.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = !checkbox.checked;
        const button_add = event.target.querySelector(".deployer-button");
        if (button_add) this.toggleAddButton(button_add);
        this.updateMainFormInputs();
        this.updateTotalPrice();
      }

      variantChanged(product) {
        const select = product.querySelector(".deployer-select");
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected);
        this.updateTotalPrice();
      }

      updateProductPrice(product, optionSelected) {
        const variantPrice = optionSelected.dataset.price;
        const compareAtPrice = product.querySelector(".toggle-cross-sell__product-compare-at-price");
        const badgeDiscount = product.querySelector(".toggle-cross-sell__product-badge-discount");
        product.querySelector(".toggle-cross-sell__product-price").innerHTML = variantPrice;

        if (optionSelected.dataset.compareAtPrice != null) {
          if (badgeDiscount != null) {
            compareAtPrice.innerHTML = optionSelected.dataset.compareAtPrice;
            compareAtPrice.style.display = "block";
          }
          if (badgeDiscount != null) {
            badgeDiscount.innerHTML = optionSelected.dataset.discountText;
            badgeDiscount.style.display = "flex";
          }
        } else {
          if (badgeDiscount != null) compareAtPrice.style.display = "none";
          if (badgeDiscount != null) badgeDiscount.style.display = "none";
        }
      }

      updateProductImage(product, optionSelected) {
        if (optionSelected.dataset.variantImage != null && product.querySelector(".toggle-cross-sell__product-image") != null) {
          const variantImage = optionSelected.dataset.variantImage;
          product.querySelector(".toggle-cross-sell__product-image img").src = variantImage;
        }
      }

      updateVariantId(product, optionSelected) {
        const variantId = optionSelected.value;
        const priceValue = optionSelected.dataset.priceValue;
        const checkbox = product.querySelector('input[type="checkbox"]');
        const button_add = product.querySelector(".deployer-button");

        if (checkbox != null) {
          checkbox.dataset.variantId = variantId;
          if (priceValue) checkbox.dataset.priceValue = priceValue;
          checkbox.checked = true;
        }
        if (button_add != null) {
          button_add.dataset.variantId = variantId;
          if (priceValue) button_add.dataset.priceValue = priceValue;
          this.toggleAddButton(button_add, true);
        }
        this.updateMainFormInputs();
      }

      resetMainFormInputs() {
        this.main_product_form.querySelectorAll(".from-toggle-cross-sell").forEach((input) => input.remove());
      }

      updateMainFormInputs() {
        this.resetMainFormInputs();

        this.querySelectorAll(".toggle-cross-sell__product").forEach((product, index) => {
          const checkbox = product.querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            this.main_product_form.insertAdjacentHTML(
              "beforeend",
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${checkbox.dataset.variantId}">`
            );
          }

          const button_add = product.querySelector(".deployer-button");
          if (button_add && button_add.classList.contains("deployer-button--active")) {
            this.main_product_form.insertAdjacentHTML(
              "beforeend",
              `<input type="hidden" class="from-toggle-cross-sell" name="items[${index + 1}][id]" value="${button_add.dataset.variantId}">`
            );
          }
        });
      }

      /**
       * Initialise le prix du produit principal depuis le formulaire
       */
      initMainProductPrice() {
        const variantIdInput = this.main_product_form?.querySelector('input[name="id"]');
        if (variantIdInput) {
          this.mainProductPrice = this.getVariantPriceFromId(variantIdInput.value);
        }
      }

      /**
       * Configure un observateur pour détecter les changements du #price-button
       * (nécessaire car d'autres scripts peuvent modifier le prix)
       */
      setupPriceButtonObserver() {
        if (!this.priceButton || !window.MutationObserver) return;

        this.priceButtonObserver = new MutationObserver((mutations) => {
          // Éviter les boucles infinies
          if (this.isUpdatingPrice) return;

          // Le prix du bouton a été modifié par un autre script
          // Extraire le nouveau prix et recalculer le total
          const newPriceText = this.priceButton.textContent.trim();
          const newPrice = this.parsePriceFromText(newPriceText);

          // Mettre à jour le prix principal et recalculer le total
          this.mainProductPrice = newPrice;

          // Attendre un court instant pour s'assurer que tous les autres scripts ont fini
          setTimeout(() => {
            this.updateTotalPrice();
          }, 10);
        });

        // Observer les changements de contenu texte
        this.priceButtonObserver.observe(this.priceButton, {
          characterData: true,
          childList: true,
          subtree: true,
        });
      }

      /**
       * Récupère le prix d'une variante depuis son ID
       * en cherchant dans les données du DOM
       */
      getVariantPriceFromId(variantId) {
        // Chercher dans les données de variante stockées dans le DOM
        const variantScript = document.querySelector('script[type="application/json"][data-variant-json]');
        if (variantScript) {
          try {
            const variants = JSON.parse(variantScript.textContent);
            const variant = variants.find((v) => v.id.toString() === variantId.toString());
            if (variant) return variant.price;
          } catch (e) {
            console.warn("ToggleCrossSell: Erreur lors du parsing des variantes", e);
          }
        }

        // Fallback : chercher dans le #price-button si disponible
        if (this.priceButton) {
          const priceText = this.priceButton.textContent.trim();
          return this.parsePriceFromText(priceText);
        }

        return 0;
      }

      /**
       * Parse un prix depuis un texte formaté (ex: "99,99 LEI")
       */
      parsePriceFromText(priceText) {
        // Nettoyer le texte et extraire le nombre
        const cleanPrice = priceText
          .replace(/[^\d,.-]/g, "") // Garder uniquement chiffres, virgules, points, tirets
          .replace(",", "."); // Convertir virgule en point

        const price = parseFloat(cleanPrice);
        return isNaN(price) ? 0 : Math.round(price * 100); // Convertir en cents
      }

      /**
       * Formate un prix en cents vers une chaîne formatée
       */
      formatPrice(priceInCents) {
        // Utiliser le formatage Shopify si disponible
        if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
          return Shopify.formatMoney(priceInCents, window.theme?.moneyFormat || "{{amount}} lei");
        }

        // Fallback : formatage simple
        const price = (priceInCents / 100).toFixed(2).replace(".", ",");
        return `${price} lei`;
      }

      /**
       * Callback appelé quand la variante du produit principal change
       */
      onMainProductVariantChange(event) {
        const variant = event.data?.variant;
        if (variant && variant.price !== undefined) {
          this.mainProductPrice = variant.price;
          this.updateTotalPrice();
        }
      }

      /**
       * Calcule le prix total des cross-sells cochés
       */
      calculateCrossSellsTotal() {
        let total = 0;

        this.querySelectorAll(".toggle-cross-sell__product").forEach((product) => {
          const checkbox = product.querySelector('input[type="checkbox"]');
          const button_add = product.querySelector(".deployer-button");
          const isSelected = (checkbox && checkbox.checked) || (button_add && button_add.classList.contains("deployer-button--active"));

          if (isSelected) {
            let priceValue = 0;

            // Si le produit a plusieurs variantes (avec select)
            const select = product.querySelector(".deployer-select");
            if (select) {
              const optionSelected = select.options[select.selectedIndex];
              const priceData = optionSelected.dataset.priceValue;

              if (priceData) {
                // Le prix est stocké en cents dans data-price-value
                priceValue = parseInt(priceData, 10);
              } else {
                // Fallback : parser depuis data-price (texte formaté)
                const priceText = optionSelected.dataset.price;
                if (priceText) {
                  priceValue = this.parsePriceFromText(priceText);
                }
              }
            } else {
              // Si le produit n'a qu'une seule variante (pas de select)
              // On récupère le prix depuis la checkbox ou le bouton
              const priceElement = checkbox || button_add;
              if (priceElement && priceElement.dataset.priceValue) {
                priceValue = parseInt(priceElement.dataset.priceValue, 10);
              }
            }

            total += priceValue;
          }
        });

        return total;
      }

      /**
       * Met à jour le prix total dans le bouton d'ajout au panier
       */
      updateTotalPrice() {
        if (!this.priceButton) return;

        const crossSellsTotal = this.calculateCrossSellsTotal();
        const totalPrice = this.mainProductPrice + crossSellsTotal;

        // Flag pour éviter que l'observateur détecte notre propre changement
        this.isUpdatingPrice = true;

        // Mettre à jour le texte du bouton
        this.priceButton.textContent = this.formatPrice(totalPrice);

        // Optionnel : ajouter une classe pour styling si des cross-sells sont ajoutés
        if (crossSellsTotal > 0) {
          this.priceButton.classList.add("has-cross-sells");
        } else {
          this.priceButton.classList.remove("has-cross-sells");
        }

        // Réactiver l'observateur après un court délai
        setTimeout(() => {
          this.isUpdatingPrice = false;
        }, 50);
      }

      /**
       * Initialise la navigation par flèches
       */
      initArrowNavigation() {
        if (!this.productsContainer || !this.arrowLeft || !this.arrowRight) return;

        // Lier les méthodes pour pouvoir les réutiliser dans cleanup
        this.scrollLeftHandler = this.scrollLeft.bind(this);
        this.scrollRightHandler = this.scrollRight.bind(this);
        this.updateArrowsStateHandler = this.updateArrowsState.bind(this);

        // Ajouter les event listeners aux flèches
        this.arrowLeft.addEventListener("click", this.scrollLeftHandler);
        this.arrowRight.addEventListener("click", this.scrollRightHandler);

        // Écouter les événements de scroll pour mettre à jour l'état des flèches
        this.productsContainer.addEventListener("scroll", this.updateArrowsStateHandler);

        // Mettre à jour l'état initial des flèches
        this.updateArrowsState();

        // Mettre à jour l'état des flèches lors du redimensionnement
        window.addEventListener("resize", this.updateArrowsStateHandler);
      }

      /**
       * Nettoie les event listeners de la navigation par flèches
       */
      cleanupArrowNavigation() {
        if (!this.productsContainer || !this.arrowLeft || !this.arrowRight) return;

        this.arrowLeft.removeEventListener("click", this.scrollLeftHandler);
        this.arrowRight.removeEventListener("click", this.scrollRightHandler);
        this.productsContainer.removeEventListener("scroll", this.updateArrowsStateHandler);
        window.removeEventListener("resize", this.updateArrowsStateHandler);
      }

      /**
       * Scroll vers la gauche (produit précédent)
       */
      scrollLeft() {
        if (!this.productsContainer) return;

        const productWidth = this.getProductWidth();
        const currentScroll = this.productsContainer.scrollLeft;
        const targetScroll = Math.max(0, currentScroll - productWidth);

        this.productsContainer.scrollTo({
          left: targetScroll,
          behavior: "smooth",
        });
      }

      /**
       * Scroll vers la droite (produit suivant)
       */
      scrollRight() {
        if (!this.productsContainer) return;

        const productWidth = this.getProductWidth();
        const currentScroll = this.productsContainer.scrollLeft;
        const maxScroll = this.productsContainer.scrollWidth - this.productsContainer.clientWidth;
        const targetScroll = Math.min(maxScroll, currentScroll + productWidth);

        this.productsContainer.scrollTo({
          left: targetScroll,
          behavior: "smooth",
        });
      }

      /**
       * Récupère la largeur d'un produit (incluant le gap)
       */
      getProductWidth() {
        const product = this.productsContainer.querySelector(".toggle-cross-sell__product");
        if (!product) return 0;

        const style = window.getComputedStyle(this.productsContainer);
        const gap = parseInt(style.gap) || 0;

        return product.offsetWidth + gap;
      }

      /**
       * Met à jour l'état désactivé/activé des flèches
       */
      updateArrowsState() {
        if (!this.productsContainer || !this.arrowLeft || !this.arrowRight) return;

        const scrollLeft = this.productsContainer.scrollLeft;
        const maxScroll = this.productsContainer.scrollWidth - this.productsContainer.clientWidth;

        // Désactiver la flèche gauche si on est tout à gauche
        if (scrollLeft <= 1) {
          // Tolérance de 1px pour les arrondis
          this.arrowLeft.disabled = true;
        } else {
          this.arrowLeft.disabled = false;
        }

        // Désactiver la flèche droite si on est tout à droite
        if (scrollLeft >= maxScroll - 1) {
          // Tolérance de 1px pour les arrondis
          this.arrowRight.disabled = true;
        } else {
          this.arrowRight.disabled = false;
        }

        // Si tout le contenu est visible (pas de scroll nécessaire), désactiver les deux flèches
        if (this.productsContainer.scrollWidth <= this.productsContainer.clientWidth) {
          this.arrowLeft.disabled = true;
          this.arrowRight.disabled = true;
        }
      }
    }
  );
}
